export default __webpack_public_path__ + "static/media/banner_centro_historico.feedb01b.JPG";